export default __webpack_public_path__ + "static/media/dz.65b5c52e.svg";